import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
	unsubscribe,
	UNSUBSCRIBE_REQUEST, UNSUBSCRIBE_SUCCESS, UNSUBSCRIBE_FAILURE } from './actions';
import { withTranslation } from 'react-i18next';
import queryString from 'query-string';
import ReduxBlockUi from 'react-block-ui/redux';
import { Alert } from 'react-bootstrap';

class Unsubscribe extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			status: 'new'
		};
	}
	componentDidMount() {
		const { configuration, parentToken } = this.props;

		if (parentToken) {
			const onSuccess = () => this.setState({ status: 'success' });
			const onError = () => this.setState({ status: 'error' });
			unsubscribe(parentToken, configuration, onSuccess, onError)
		}
	}

	render() {
		const { t, configuration: { franchisor }, parentToken } = this.props;
		return (
			<div className='franchise-portal'>
				<ReduxBlockUi block={UNSUBSCRIBE_REQUEST} unblock={[UNSUBSCRIBE_SUCCESS, UNSUBSCRIBE_FAILURE]}>
					<div>
						<h3>{t('FO_Unsubscribe_Title')}</h3>
						{this.state.status == 'new' && parentToken && <p> {t('FO_Unsubscribe_Processing')}</p>}
						{this.state.status == 'success' && <Alert bsStyle='success'> {t('FO_Unsubscribe_Success')}</Alert>}
						{this.state.status == 'error' && <Alert bsStyle='warning'> {t('FO_Unsubscribe_Failed', { email: franchisor.companyEmail })}</Alert>}
					</div>
				</ReduxBlockUi>
			</div>
		);
	}
}

Unsubscribe.propTypes = {
	unsubscribe: PropTypes.func,
	location: PropTypes.object
};

const mapStateToProps = (state, ownProps) => {
	const { parentToken } = queryString.parse(ownProps.location.search);
	const { configuration } = state;

	return {
		parentToken,
		configuration
	};
};

export default connect(mapStateToProps, {
	unsubscribe
})(withTranslation()(Unsubscribe));